// extracted by mini-css-extract-plugin
export default {"layout":"RoomDetails_layout__n6Ugb"};